import {MacOSCursor} from '@remotion/mac-cursors';
import {Video} from '@remotion/media';
import {
	AbsoluteFill,
	Composition,
	Easing,
	interpolate,
	useCurrentFrame,
} from 'remotion';
import {CloseUpFrame} from './CloseUpFrame';

const KeyframeMoveContent = () => {
	const frame = useCurrentFrame();

	return (
		<AbsoluteFill
			name="Canvas Capture"
			style={{
				width: 3860,
				height: 2284,
				translate: '-1197.7px -902px',
				rotate: '0.797028 0.589106 -0.13304 28.019126deg',
				scale: 0.67,
			}}
			from={-552}
		>
			<Video
				src="https://remotion.media/studio-close-ups/keyframe-move-2026-09-23.mp4"
				durationInFrames={917}
				style={{
					position: 'absolute',
				}}
			/>
			<MacOSCursor
				cursor={interpolate(
					frame,
					[
						-550, -425, -307, -306, -302, -301, -300, -299, -295, -294, -288,
						-287, -283, -282, -278, -277, -276, -275, -255, -245, -127, -126,
						-116, 7, 10, 15, 19, 24, 66, 68, 75, 76, 141,
					],
					[
						'auto',
						'default',
						'auto',
						'default',
						'auto',
						'default',
						'auto',
						'default',
						'auto',
						'default',
						'auto',
						'default',
						'auto',
						'default',
						'auto',
						'default',
						'auto',
						'default',
						'auto',
						'default',
						'auto',
						'default',
						'auto',
						'default',
						'auto',
						'default',
						'auto',
						'default',
						'auto',
						'default',
						'auto',
						'default',
						'auto',
					],
					{
						easing: [
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
						],

						extrapolateLeft: 'clamp',
						extrapolateRight: 'clamp',
					},
				)}
				style={{
					position: 'absolute',
					left: 0,
					top: 0,
					scale: interpolate(
						frame,
						[
							-552, -499, -492, -452, -401, -381, -119, -30, -24, 3, 35, 60,
							211, 283, 289,
						],
						[
							4.1, 3.69, 4.1, 3.69, 4.1, 3.69, 4.1, 3.69, 4.1, 3.69, 4.1, 3.69,
							4.1, 3.69, 4.1,
						],
						{
							easing: [
								Easing.step1,
								Easing.step1,
								Easing.step1,
								Easing.step1,
								Easing.step1,
								Easing.step1,
								Easing.step1,
								Easing.step1,
								Easing.step1,
								Easing.step1,
								Easing.step1,
								Easing.step1,
								Easing.step1,
								Easing.step1,
							],
							extrapolateLeft: 'clamp',
							extrapolateRight: 'clamp',
						},
					),
					translate: interpolate(
						frame,
						[
							-550, -549, -539, -538, -537, -536, -535, -534, -533, -532, -531,
							-530, -529, -528, -527, -525, -524, -523, -522, -519, -518, -517,
							-516, -515, -514, -513, -511, -510, -509, -508, -507, -506, -505,
							-504, -503, -502, -492, -491, -490, -489, -488, -487, -486, -485,
							-484, -483, -482, -481, -480, -479, -478, -477, -476, -475, -474,
							-473, -472, -471, -470, -469, -468, -467, -466, -465, -464, -463,
							-462, -461, -460, -459, -458, -457, -456, -455, -454, -453, -452,
							-451, -450, -449, -448, -447, -446, -445, -444, -443, -442, -441,
							-440, -439, -438, -437, -436, -435, -434, -433, -432, -431, -430,
							-429, -428, -427, -426, -425, -424, -423, -422, -421, -420, -419,
							-418, -417, -416, -415, -414, -413, -412, -411, -410, -409, -408,
							-407, -406, -405, -404, -400, -399, -398, -397, -396, -395, -394,
							-393, -392, -390, -389, -388, -387, -368, -367, -366, -365, -364,
							-363, -362, -361, -360, -359, -358, -357, -356, -355, -354, -353,
							-352, -351, -350, -349, -348, -347, -346, -345, -344, -343, -342,
							-341, -340, -339, -338, -337, -336, -335, -334, -333, -332, -331,
							-330, -329, -328, -327, -326, -325, -324, -323, -311, -310, -309,
							-308, -307, -306, -305, -304, -303, -302, -301, -300, -299, -298,
							-297, -296, -295, -294, -293, -292, -291, -290, -289, -288, -287,
							-286, -285, -284, -283, -282, -281, -280, -279, -278, -277, -276,
							-275, -274, -256, -255, -246, -245, -244, -243, -242, -241, -240,
							-239, -238, -237, -236, -235, -234, -233, -232, -231, -230, -229,
							-228, -227, -226, -225, -224, -223, -222, -221, -220, -219, -218,
							-217, -216, -215, -214, -213, -212, -211, -210, -209, -208, -207,
							-206, -205, -204, -203, -202, -201, -200, -199, -198, -197, -196,
							-195, -194, -193, -192, -191, -190, -189, -188, -187, -186, -185,
							-184, -183, -182, -181, -180, -179, -178, -177, -176, -175, -174,
							-173, -172, -171, -170, -169, -168, -167, -166, -165, -164, -163,
							-162, -161, -159, -158, -157, -156, -155, -154, -153, -138, -137,
							-136, -135, -134, -133, -132, -131, -130, -129, -128, -127, -126,
							-125, -124, -123, -122, -121, -120, -119, -118, -117, -116, -115,
							-114, -113, -112, -111, -110, -109, -108, -107, -106, -105, -104,
							-103, -102, -101, -100, -99, -98, -97, -96, -95, -94, -93, -92,
							-91, -90, -89, -88, -87, -86, -85, -84, -72, -71, -70, -69, -68,
							-67, -66, -65, -64, -63, -62, -61, -60, -59, -56, -55, -54, -53,
							-52, -51, -50, -49, -48, -43, -42, -41, -40, -39, -38, -37, -36,
							-35, -26, -25, -24, -23, -22, -21, -20, -19, -18, -17, -16, -15,
							-14, -13, -12, -11, -10, -9, -8, -7, -6, -5, -4, -3, -2, -1, 0, 3,
							4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21,
							22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 39, 40, 41,
							42, 43, 44, 45, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70,
							71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86,
							87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102,
							103, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122,
							123, 124, 125, 126, 127, 128, 129, 130, 131, 132, 133, 134, 135,
							136, 137, 138, 139, 140, 141, 142, 143, 144, 145, 146, 147, 148,
							149, 150, 151, 152, 153, 154, 155, 156, 157, 158, 159, 160, 161,
							162, 163, 164, 165, 166, 167, 168, 169, 170, 171, 172, 173, 174,
							175, 176, 177, 178, 179, 180, 181, 182, 183, 184, 185, 186, 187,
							188, 189, 190, 191, 192, 197, 198, 199, 211, 212, 213, 214, 215,
							216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228,
							229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241,
							242, 243, 244, 245, 246, 247, 248, 249, 250, 251, 252, 253, 254,
							255, 256, 262, 263, 264, 265, 266, 267, 268, 269, 270, 271, 272,
							273, 274, 275,
						],
						[
							'4047.5488281249995px 1904.433984375px',
							'4032.3019531249997px 1901.230859375px',
							'4032.3019531249997px 1901.230859375px',
							'2805.39296875px 1772.8496093749998px',
							'2763.43203125px 1763.4484375px',
							'2735.9972656249997px 1757.5546874999998px',
							'2717.7554687499996px 1754.4156249999999px',
							'2707.4414062499995px 1753.5027343749998px',
							'2690.6089843749996px 1750.7640625px',
							'2674.865625px 1746.43984375px',
							'2660.22734375px 1743.508984375px',
							'2650.2335937499997px 1741.50703125px',
							'2648.0874999999996px 1741.234765625px',
							'2645.3007812499995px 1741.0265625px',
							'2644.6921875px 1741.0265625px',
							'2644.6921875px 1741.0265625px',
							'2645.49296875px 1740.99453125px',
							'2649.5449218749995px 1740.4499999999998px',
							'2650.858203125px 1740.4499999999998px',
							'2650.858203125px 1740.4499999999998px',
							'2644.6601562499995px 1738.191796875px',
							'2590.4312499999996px 1725.379296875px',
							'2483.7511718749997px 1693.1238281249998px',
							'2397.0425781249996px 1672.7039062499998px',
							'2395.1046874999997px 1672.527734375px',
							'2385.9117187499996px 1671.726953125px',
							'2385.9117187499996px 1671.726953125px',
							'2384.56640625px 1676.1792968749999px',
							'2382.404296875px 1692.0347656249999px',
							'2381.9078124999996px 1720.766796875px',
							'2381.9078124999996px 1755.200390625px',
							'2381.859765625px 1771.8886718749998px',
							'2381.29921875px 1785.117578125px',
							'2381.29921875px 1794.3425781249998px',
							'2381.155078125px 1798.20234375px',
							'2380.9468749999996px 1800.012109375px',
							'2380.9468749999996px 1800.012109375px',
							'2365.203515625px 1799.29140625px',
							'2283.02734375px 1802.6386718749998px',
							'2255.09609375px 1804.976953125px',
							'2207.7859375px 1814.2019531249998px',
							'2154.918359375px 1827.9273437499999px',
							'2137.5734374999997px 1831.51484375px',
							'2128.95703125px 1832.523828125px',
							'2126.90703125px 1832.523828125px',
							'2126.1703125px 1832.523828125px',
							'2125.930078125px 1832.523828125px',
							'2124.424609375px 1833.4687499999998px',
							'2124.104296875px 1833.6929687499999px',
							'2123.0953124999996px 1834.157421875px',
							'2122.1183593749997px 1834.3335937499999px',
							'2120.548828125px 1835.35859375px',
							'2119.1554687499997px 1836.44765625px',
							'2117.265625px 1839.4585937499999px',
							'2114.8472656249996px 1844.9679687499997px',
							'2113.5660156249996px 1852.9117187499999px',
							'2113.021484375px 1859.1257812499998px',
							'2112.957421875px 1863.1777343749998px',
							'2112.380859375px 1869.840234375px',
							'2112.4609375px 1874.8691406249998px',
							'2112.87734375px 1878.9851562499998px',
							'2112.957421875px 1879.4816406249997px',
							'2112.957421875px 1879.9941406249998px',
							'2113.277734375px 1881.0191406249999px',
							'2114.09453125px 1882.3003906249999px',
							'2114.31875px 1883.5816406249999px',
							'2114.6390625px 1884.3664062499997px',
							'2114.6390625px 1884.4304687499998px',
							'2114.6390625px 1885.1511718749998px',
							'2114.6390625px 1885.45546875px',
							'2114.6390625px 1885.8718749999998px',
							'2114.6390625px 1886.3042968749999px',
							'2114.334765625px 1886.7847656249999px',
							'2114.15859375px 1886.9449218749999px',
							'2114.15859375px 1887.5214843749998px',
							'2114.15859375px 1887.5214843749998px',
							'2113.7421875px 1887.5214843749998px',
							'2113.7421875px 1887.5214843749998px',
							'2110.475px 1886.7527343749998px',
							'2091.9609375px 1881.0191406249999px',
							'2067.296875px 1871.4578124999998px',
							'2049.45546875px 1863.9464843749997px',
							'2040.1984374999997px 1859.910546875px',
							'2030.1085937499997px 1854.8976562499997px',
							'2024.9835937499997px 1851.262109375px',
							'2024.9835937499997px 1851.262109375px',
							'2008.3113281249998px 1835.35859375px',
							'2004.2753906249998px 1830.1054687499998px',
							'1999.3906249999998px 1823.9394531249998px',
							'1991.1105468749997px 1813.5292968749998px',
							'1978.6343749999999px 1797.9460937499998px',
							'1970.3062499999999px 1787.76015625px',
							'1963.0351562499998px 1777.942578125px',
							'1956.9812499999998px 1769.7906249999999px',
							'1949.3738281249998px 1759.332421875px',
							'1943.9125px 1750.6999999999998px',
							'1938.3710937499998px 1741.4429687499999px',
							'1935.6003906249998px 1737.070703125px',
							'1932.461328125px 1733.146875px',
							'1928.8578125px 1728.7265624999998px',
							'1922.7398437499999px 1723.649609375px',
							'1918.3195312499997px 1718.8769531249998px',
							'1912.6499999999999px 1712.51875px',
							'1908.6621093749998px 1706.9453124999998px',
							'1903.7292968749998px 1701.115625px',
							'1899.2449218749998px 1696.63125px',
							'1897.5953124999999px 1695.06171875px',
							'1896.8746093749999px 1694.1968749999999px',
							'1896.1859375px 1693.3960937499999px',
							'1893.9597656249998px 1691.9707031249998px',
							'1891.7175781249998px 1690.9617187499998px',
							'1889.3312499999997px 1689.1359375px',
							'1888.5464843749999px 1688.5593749999998px',
							'1887.9539062499998px 1687.614453125px',
							'1886.3523437499998px 1685.4843749999998px',
							'1884.7828124999999px 1683.6425781249998px',
							'1883.21328125px 1681.8648437499999px',
							'1882.2363281249998px 1680.2632812499999px',
							'1881.3074218749998px 1678.40546875px',
							'1880.7789062499999px 1676.6757812499998px',
							'1879.8339843749998px 1674.2734374999998px',
							'1879.6578124999999px 1673.8249999999998px',
							'1879.209375px 1672.047265625px',
							'1879.1933593749998px 1671.9031249999998px',
							'1879.1933593749998px 1671.6949218749999px',
							'1879.1933593749998px 1671.6949218749999px',
							'1879.4656249999998px 1671.9671875px',
							'1880.97109375px 1673.2164062499999px',
							'1884.7187499999998px 1675.52265625px',
							'1885.5515624999998px 1676.3874999999998px',
							'1885.8238281249999px 1676.9480468749998px',
							'1885.9999999999998px 1677.3964843749998px',
							'1886.3523437499998px 1677.812890625px',
							'1886.4324218749998px 1677.89296875px',
							'1886.4324218749998px 1677.89296875px',
							'1886.4324218749998px 1677.9890624999998px',
							'1886.4324218749998px 1677.9890624999998px',
							'1886.4324218749998px 1678.485546875px',
							'1886.4324218749998px 1678.485546875px',
							'1876.6628906249998px 1679.04609375px',
							'1866.0124999999998px 1679.3824218749999px',
							'1866.0124999999998px 1679.3824218749999px',
							'1858.6453124999998px 1679.81484375px',
							'1854.2570312499997px 1679.894921875px',
							'1852.46328125px 1680.087109375px',
							'1849.7726562499997px 1680.087109375px',
							'1848.0109374999997px 1680.087109375px',
							'1844.6476562499997px 1680.087109375px',
							'1841.6367187499998px 1680.215234375px',
							'1839.33046875px 1680.3433593749999px',
							'1837.0242187499998px 1680.3433593749999px',
							'1834.8140624999999px 1680.6796874999998px',
							'1833.1484374999998px 1680.727734375px',
							'1831.4667968749998px 1680.727734375px',
							'1830.4257812499998px 1680.727734375px',
							'1829.6890624999999px 1680.727734375px',
							'1828.0554687499998px 1680.727734375px',
							'1825.156640625px 1680.727734375px',
							'1822.3699218749998px 1680.727734375px',
							'1820.5921875px 1680.727734375px',
							'1819.4070312499998px 1680.727734375px',
							'1818.6062499999998px 1681.048046875px',
							'1816.540234375px 1681.048046875px',
							'1815.49921875px 1681.048046875px',
							'1814.5542968749999px 1681.048046875px',
							'1813.337109375px 1681.048046875px',
							'1812.2320312499999px 1681.048046875px',
							'1811.175px 1681.048046875px',
							'1808.532421875px 1681.048046875px',
							'1806.1460937499999px 1681.3523437499998px',
							'1804.528515625px 1681.3843749999999px',
							'1802.1582031249998px 1681.3843749999999px',
							'1800.044140625px 1681.3843749999999px',
							'1798.2343749999998px 1681.3843749999999px',
							'1795.848046875px 1681.3843749999999px',
							'1793.926171875px 1681.3843749999999px',
							'1792.1484374999998px 1681.3843749999999px',
							'1790.4507812499999px 1681.3843749999999px',
							'1789.1695312499999px 1681.3843749999999px',
							'1787.8562499999998px 1681.3843749999999px',
							'1786.558984375px 1681.3843749999999px',
							'1785.9664062499999px 1681.3843749999999px',
							'1785.630078125px 1681.3843749999999px',
							'1785.38984375px 1681.3843749999999px',
							'1785.38984375px 1681.3843749999999px',
							'1795.96015625px 1681.3843749999999px',
							'1817.6132812499998px 1682.3613281249998px',
							'1817.6132812499998px 1682.3613281249998px',
							'1834.766015625px 1683.1460937499999px',
							'1848.0910156249997px 1683.8027343749998px',
							'1852.6234375px 1684.0749999999998px',
							'1854.865625px 1684.3472656249999px',
							'1856.6593749999997px 1684.571484375px',
							'1876.3906249999998px 1684.571484375px',
							'1907.4449218749999px 1685.532421875px',
							'1916.5417968749998px 1685.6445312499998px',
							'1927.3042968749999px 1686.781640625px',
							'1932.4773437499998px 1686.9097656249999px',
							'1942.4230468749997px 1687.582421875px',
							'1954.242578125px 1687.9988281249998px',
							'1970.3863281249999px 1687.9988281249998px',
							'1984.8003906249999px 1687.9988281249998px',
							'2001.4726562499998px 1687.9988281249998px',
							'2011.0499999999997px 1688.3992187499998px',
							'2022.949609375px 1688.4792968749998px',
							'2030.3007812499998px 1688.9277343749998px',
							'2040.4707031249998px 1689.0878906249998px',
							'2055.28515625px 1689.8726562499999px',
							'2067.376953125px 1690.57734375px',
							'2074.37578125px 1691.0417968749998px',
							'2080.4937499999996px 1691.53828125px',
							'2089.2863281249997px 1692.17890625px',
							'2098.0949218749997px 1693.3px',
							'2115.37578125px 1694.22890625px',
							'2120.8531249999996px 1694.6132812499998px',
							'2127.467578125px 1695.0136718749998px',
							'2135.1710937499997px 1695.1738281249998px',
							'2144.7804687499997px 1695.83046875px',
							'2160.0914062499996px 1696.230859375px',
							'2184.8195312499997px 1696.8874999999998px',
							'2198.1925781249997px 1697.4640625px',
							'2209.8359375px 1698.1046875px',
							'2209.8359375px 1698.1046875px',
							'2281.5859375px 1702.7171875px',
							'2281.5859375px 1702.7171875px',
							'2279.8082031249996px 1702.7171875px',
							'2279.8082031249996px 1702.7171875px',
							'2273.7863281249997px 1702.7171875px',
							'2266.8355468749996px 1702.7171875px',
							'2260.5734374999997px 1703.0054687499999px',
							'2252.9019531249996px 1703.2136718749998px',
							'2242.02734375px 1703.2136718749998px',
							'2231.3609374999996px 1703.2136718749998px',
							'2203.701953125px 1703.2136718749998px',
							'2193.4359375px 1703.2136718749998px',
							'2189.2238281249997px 1703.2136718749998px',
							'2183.890625px 1703.2136718749998px',
							'2177.404296875px 1703.38984375px',
							'2172.375390625px 1703.598046875px',
							'2165.40859375px 1703.598046875px',
							'2161.805078125px 1703.598046875px',
							'2158.29765625px 1703.598046875px',
							'2155.3507812499997px 1703.598046875px',
							'2151.1066406249997px 1703.598046875px',
							'2143.771484375px 1703.598046875px',
							'2135.123046875px 1703.598046875px',
							'2127.8199218749996px 1703.598046875px',
							'2121.541796875px 1703.598046875px',
							'2112.8292968749997px 1703.598046875px',
							'2104.80546875px 1703.9984375px',
							'2092.0890624999997px 1704.078515625px',
							'2083.40859375px 1703.5820312499998px',
							'2069.73125px 1703.5820312499998px',
							'2062.7003906249997px 1703.5820312499998px',
							'2057.9757812499997px 1703.5820312499998px',
							'2053.3472656249996px 1703.5820312499998px',
							'2048.894921875px 1703.8542968749998px',
							'2044.9550781249998px 1704.03046875px',
							'2038.7089843749998px 1704.03046875px',
							'2033.3437499999998px 1704.4468749999999px',
							'2026.6972656249998px 1704.4628906249998px',
							'2016.94375px 1704.4628906249998px',
							'2006.3734375px 1704.4628906249998px',
							'1995.5148437499997px 1704.4628906249998px',
							'1988.2437499999999px 1704.4628906249998px',
							'1981.22890625px 1704.15859375px',
							'1976.6804687499998px 1703.950390625px',
							'1972.4523437499997px 1703.950390625px',
							'1968.8808593749998px 1703.950390625px',
							'1965.1972656249998px 1703.950390625px',
							'1962.2664062499998px 1703.950390625px',
							'1959.3835937499998px 1703.950390625px',
							'1956.1964843749997px 1703.950390625px',
							'1952.2246093749998px 1703.950390625px',
							'1948.476953125px 1703.950390625px',
							'1945.273828125px 1703.950390625px',
							'1943.2238281249997px 1703.950390625px',
							'1941.6382812499999px 1703.950390625px',
							'1934.7996093749998px 1703.2937499999998px',
							'1928.3132812499998px 1703.2937499999998px',
							'1922.371484375px 1703.1656249999999px',
							'1915.9972656249997px 1702.829296875px',
							'1909.4468749999999px 1702.5890625px',
							'1904.7382812499998px 1702.3328124999998px',
							'1895.8015624999998px 1702.3328124999998px',
							'1886.4324218749998px 1702.3328124999998px',
							'1880.9550781249998px 1701.9324218749998px',
							'1878.6808593749997px 1701.8203124999998px',
							'1874.8691406249998px 1701.4359375px',
							'1870.2085937499999px 1701.4359375px',
							'1867.1816406249998px 1701.2917968749998px',
							'1864.5070312499997px 1701.0515624999998px',
							'1862.2488281249998px 1700.8113281249998px',
							'1859.6542968749998px 1700.6671875px',
							'1855.5222656249998px 1700.6671875px',
							'1848.8437499999998px 1700.0906249999998px',
							'1846.8417968749998px 1700.0425781249999px',
							'1844.375390625px 1700.0425781249999px',
							'1841.5246093749997px 1700.0425781249999px',
							'1838.4656249999998px 1699.8984374999998px',
							'1836.7999999999997px 1699.6582031249998px',
							'1835.0222656249998px 1699.6582031249998px',
							'1832.203515625px 1699.6582031249998px',
							'1828.2636718749998px 1699.6582031249998px',
							'1823.3789062499998px 1699.6582031249998px',
							'1816.6363281249999px 1699.6582031249998px',
							'1816.6363281249999px 1699.6582031249998px',
							'1807.459375px 1699.6582031249998px',
							'1807.379296875px 1699.6582031249998px',
							'1807.251171875px 1699.6582031249998px',
							'1807.251171875px 1699.6582031249998px',
							'1806.1621093749998px 1699.6582031249998px',
							'1803.535546875px 1699.6582031249998px',
							'1803.1191406249998px 1699.6582031249998px',
							'1801.40546875px 1699.6582031249998px',
							'1799.16328125px 1699.6582031249998px',
							'1798.570703125px 1699.6582031249998px',
							'1798.570703125px 1699.6582031249998px',
							'1801.8378906249998px 1699.6582031249998px',
							'1810.1499999999999px 1699.6582031249998px',
							'1819.2789062499999px 1699.8984374999998px',
							'1829.0964843749998px 1700.5390624999998px',
							'1840.2273437499998px 1701.2117187499998px',
							'1845.3042968749999px 1701.5320312499998px',
							'1848.9878906249999px 1701.548046875px',
							'1852.5273437499998px 1701.9003906249998px',
							'1856.3550781249999px 1701.91640625px',
							'1863.03359375px 1701.91640625px',
							'1869.7761718749998px 1702.0765625px',
							'1876.80703125px 1702.637109375px',
							'1879.9621093749997px 1702.8613281249998px',
							'1882.2042968749997px 1703.0855468749999px',
							'1884.3664062499997px 1703.2136718749998px',
							'1887.0410156249998px 1703.2136718749998px',
							'1891.2691406249999px 1703.6941406249998px',
							'1902.8644531249997px 1703.7261718749999px',
							'1908.7421874999998px 1704.15859375px',
							'1909.2707031249997px 1704.2546874999998px',
							'1911.1445312499998px 1704.5109375px',
							'1913.082421875px 1704.7351562499998px',
							'1916.0933593749999px 1704.9433593749998px',
							'1923.6367187499998px 1705.471875px',
							'1931.1640624999998px 1706.08046875px',
							'1932.461328125px 1706.1445312499998px',
							'1933.7105468749999px 1706.4488281249999px',
							'1933.902734375px 1706.4488281249999px',
							'1935.4402343749998px 1706.4488281249999px',
							'1936.9136718749999px 1706.5449218749998px',
							'1937.8906249999998px 1706.673046875px',
							'1938.5312499999998px 1706.673046875px',
							'1939.2999999999997px 1707.0574218749998px',
							'1940.2449218749998px 1707.521875px',
							'1943.1437499999997px 1708.0664062499998px',
							'1951.4238281249998px 1708.1304687499999px',
							'1967.4074218749997px 1708.9953125px',
							'1982.9425781249997px 1709.7800781249998px',
							'1999.4386718749997px 1710.9171875px',
							'2021.1398437499997px 1712.726953125px',
							'2050.5285156249997px 1714.808984375px',
							'2105.173828125px 1718.652734375px',
							'2176.3472656249996px 1731.8015624999998px',
							'2277.6140625px 1756.769921875px',
							'2297.873828125px 1762.96796875px',
							'2328.9601562499997px 1774.258984375px',
							'2360.3507812499997px 1783.2117187499998px',
							'2360.943359375px 1783.355859375px',
							'2361.904296875px 1783.355859375px',
							'2364.2746093749997px 1783.6601562499998px',
							'2366.388671875px 1783.7402343749998px',
							'2367.3976562499997px 1783.7402343749998px',
							'2367.445703125px 1783.7402343749998px',
							'2367.7980468749997px 1783.7402343749998px',
							'2367.7980468749997px 1783.7402343749998px',
							'2368.182421875px 1783.7402343749998px',
							'2368.6949218749996px 1783.7402343749998px',
							'2372.2824218749997px 1783.227734375px',
							'2389.94765625px 1783.14765625px',
							'2426.4312499999996px 1783.0035156249999px',
							'2472.892578125px 1781.8984374999998px',
							'2511.6343749999996px 1781.8984374999998px',
							'2583.3203125px 1782.587109375px',
							'2648.4238281249995px 1784.7171875px',
							'2684.7472656249997px 1787.43984375px',
							'2698.5527343749995px 1788.7050781249998px',
							'2704.1582031249995px 1789.633984375px',
							'2705.23125px 1789.8582031249998px',
							'2705.23125px 1789.8582031249998px',
							'2704.6546875px 1790.2265624999998px',
							'2694.82109375px 1794.0542968749999px',
							'2657.98515625px 1806.0339843749998px',
							'2588.6535156249997px 1821.7292968749998px',
							'2541.6476562499997px 1832.1714843749999px',
							'2522.5249999999996px 1838.6257812499998px',
							'2512.931640625px 1842.1492187499998px',
							'2512.9156249999996px 1842.1492187499998px',
							'2512.9156249999996px 1842.1492187499998px',
							'2509.7124999999996px 1842.1492187499998px',
							'2463.058984375px 1842.1492187499998px',
							'2429.650390625px 1842.1492187499998px',
							'2403.5128906249997px 1842.1492187499998px',
							'2362.0484374999996px 1842.2613281249999px',
							'2343.7105468749996px 1842.69375px',
							'2327.80703125px 1842.69375px',
							'2324.828125px 1842.69375px',
							'2324.828125px 1842.69375px',
							'2324.828125px 1843.094140625px',
							'2323.178515625px 1844.375390625px',
							'2301.397265625px 1850.0449218749998px',
							'2271.43203125px 1853.664453125px',
							'2221.126953125px 1859.0136718749998px',
							'2197.11953125px 1861.8964843749998px',
							'2160.7640625px 1864.6671874999997px',
							'2144.2199218749997px 1865.3078124999997px',
							'2142.8265625px 1865.4679687499997px',
							'2140.920703125px 1866.0925781249998px',
							'2135.155078125px 1867.83828125px',
							'2130.43046875px 1869.7441406249998px',
							'2127.595703125px 1871.3136718749997px',
							'2124.66484375px 1873.5558593749997px',
							'2119.86015625px 1876.3746093749999px',
							'2118.9953124999997px 1877.2875px',
							'2118.178515625px 1877.9121093749998px',
							'2117.7941406249997px 1878.2804687499997px',
							'2117.7941406249997px 1878.2964843749999px',
							'2116.9132812499997px 1880.0582031249999px',
							'2115.215625px 1884.414453125px',
							'2111.7082031249997px 1892.8386718749998px',
							'2110.234765625px 1896.0417968749998px',
							'2108.8414062499996px 1898.5722656249998px',
							'2108.1847656249997px 1899.9656249999998px',
							'2107.7843749999997px 1900.5582031249999px',
							'2107.7843749999997px 1900.5582031249999px',
							'2106.166796875px 1900.1417968749997px',
							'2076.2015625px 1894.0718749999999px',
							'2023.3339843749998px 1878.3605468749997px',
							'1992.2316406249997px 1869.0554687499998px',
							'1978.7945312499999px 1864.5710937499998px',
							'1950.9753906249998px 1852.9757812499997px',
							'1934.14296875px 1843.3503906249998px',
							'1912.281640625px 1827.959375px',
							'1901.1187499999999px 1817.789453125px',
							'1898.027734375px 1814.1539062499999px',
							'1896.9386718749997px 1812.2640625px',
							'1893.8796874999998px 1801.2292968749998px',
							'1891.6054687499998px 1791.2195312499998px',
							'1887.0730468749998px 1778.4871093749998px',
							'1878.4406249999997px 1759.2683593749998px',
							'1870.08046875px 1739.8093749999998px',
							'1866.2046874999999px 1729.543359375px',
							'1864.5390624999998px 1723.329296875px',
							'1863.4660156249997px 1717.7398437499999px',
							'1863.3699218749998px 1709.363671875px',
							'1862.8414062499999px 1701.6921874999998px',
							'1862.8414062499999px 1695.590234375px',
							'1862.8414062499999px 1691.618359375px',
							'1862.8414062499999px 1689.5203124999998px',
							'1863.3378906249998px 1686.7015625px',
							'1864.1546875px 1684.251171875px',
							'1864.9874999999997px 1682.1210937499998px',
							'1865.8683593749997px 1679.894921875px',
							'1865.9324218749998px 1678.3894531249998px',
							'1865.9484374999997px 1678.3093749999998px',
							'1865.9484374999997px 1678.0210937499999px',
							'1865.9484374999997px 1678.0210937499999px',
							'1867.6140624999998px 1678.0210937499999px',
							'1874.484765625px 1679.3503906249998px',
							'1876.16640625px 1679.5906249999998px',
							'1876.16640625px 1679.5906249999998px',
							'1876.3105468749998px 1679.5906249999998px',
							'1876.5507812499998px 1679.5906249999998px',
							'1876.5507812499998px 1679.5906249999998px',
							'1878.1523437499998px 1680.3914062499998px',
							'1878.1523437499998px 1680.3914062499998px',
							'1883.21328125px 1681.016015625px',
							'1901.5992187499999px 1683.0660156249999px',
							'1917.8230468749998px 1684.5874999999999px',
							'1936.8335937499999px 1685.7246093749998px',
							'1973.4773437499998px 1687.8546875px',
							'2012.6515624999997px 1689.2320312499999px',
							'2045.8679687499998px 1690.225px',
							'2045.8679687499998px 1690.225px',
							'2071.9253906249996px 1690.89765625px',
							'2084.465625px 1690.89765625px',
							'2102.323046875px 1691.34609375px',
							'2128.9410156249996px 1691.8265625px',
							'2167.730859375px 1691.8265625px',
							'2202.1324218749996px 1692.5152343749999px',
							'2208.9230468749997px 1692.6433593749998px',
							'2216.3703124999997px 1692.6433593749998px',
							'2222.2960937499997px 1692.7234374999998px',
							'2229.246875px 1693.1558593749999px',
							'2238.583984375px 1693.700390625px',
							'2249.026171875px 1694.821484375px',
							'2253.318359375px 1695.0296875px',
							'2257.2902343749997px 1695.35px',
							'2260.9578125px 1695.4781249999999px',
							'2269.7984374999996px 1696.102734375px',
							'2281.217578125px 1696.1667968749998px',
							'2289.994140625px 1696.7593749999999px',
							'2296.592578125px 1697.1597656249999px',
							'2301.8296874999996px 1697.3199218749999px',
							'2306.426171875px 1697.5921875px',
							'2312.7843749999997px 1697.9605468749999px',
							'2323.5949218749997px 1698.6972656249998px',
							'2333.4445312499997px 1698.8734375px',
							'2342.15703125px 1698.8734375px',
							'2350.5011718749997px 1699.466015625px',
							'2359.7261718749996px 1700.0105468749998px',
							'2365.1554687499997px 1700.1226562499999px',
							'2370.8570312499996px 1700.4109374999998px',
							'2375.9820312499996px 1700.4109374999998px',
							'2378.4644531249996px 1700.63515625px',
							'2378.99296875px 1700.715234375px',
							'2379.1691406249997px 1700.715234375px',
							'2379.1851562499996px 1700.715234375px',
							'2379.1851562499996px 1700.715234375px',
							'2377.9679687499997px 1700.715234375px',
							'2373.0191406249996px 1700.747265625px',
							'2366.708984375px 1701.3398437499998px',
							'2351.590234375px 1702.188671875px',
							'2331.1222656249997px 1702.797265625px',
							'2306.6183593749997px 1703.2937499999998px',
							'2284.068359375px 1704.1425781249998px',
							'2267.3800781249997px 1704.3828124999998px',
							'2252.95px 1704.3828124999998px',
							'2237.4308593749997px 1704.3828124999998px',
							'2237.4308593749997px 1704.3828124999998px',
							'2202.5328124999996px 1705.4558593749998px',
							'2155.1105468749997px 1705.6960937499998px',
							'2135.6515624999997px 1706.1765624999998px',
							'2120.62890625px 1706.1765624999998px',
							'2112.412890625px 1706.4167968749998px',
							'2103.7484375px 1706.5609375px',
							'2091.67265625px 1706.5609375px',
							'2081.470703125px 1706.5449218749998px',
							'2080.701953125px 1706.480859375px',
							'2079.100390625px 1706.480859375px',
							'2076.7140624999997px 1706.480859375px',
							'2072.854296875px 1706.480859375px',
							'2069.05859375px 1706.6089843749999px',
							'2067.16875px 1706.7371093749998px',
							'2063.693359375px 1706.7371093749998px',
							'2059.225px 1707.1695312499999px',
							'2049.2472656249997px 1707.2496093749999px',
							'2032.9433593749998px 1708.082421875px',
							'2018.1769531249997px 1708.7390624999998px',
							'2008.7277343749997px 1708.883203125px',
							'1999.9031249999998px 1709.235546875px',
							'1993.6089843749999px 1709.44375px',
							'1989.316796875px 1709.8601562499998px',
							'1989.316796875px 1709.8601562499998px',
							'1981.789453125px 1709.9882812499998px',
							'1978.2019531249998px 1709.9882812499998px',
							'1974.4542968749997px 1710.4046875px',
							'1970.898828125px 1710.4046875px',
							'1967.1511718749998px 1710.4046875px',
							'1960.5527343749998px 1710.4046875px',
							'1951.1835937499998px 1710.4046875px',
							'1937.9707031249998px 1710.4046875px',
							'1929.9628906249998px 1710.7410156249998px',
							'1924.453515625px 1710.8531249999999px',
							'1922.3874999999998px 1711.0453125px',
							'1919.4726562499998px 1711.0453125px',
							'1918.0152343749999px 1711.125390625px',
							'1915.3726562499999px 1711.4937499999999px',
							'1913.1945312499997px 1711.4937499999999px',
							'1910.4238281249998px 1711.4937499999999px',
							'1908.8863281249999px 1711.4937499999999px',
							'1906.8683593749997px 1711.84609375px',
							'1902.832421875px 1711.958203125px',
							'1896.6984374999997px 1711.958203125px',
							'1892.2140624999997px 1712.3746093749999px',
							'1889.459375px 1712.3746093749999px',
							'1887.7296874999997px 1712.3746093749999px',
							'1887.297265625px 1712.3746093749999px',
							'1887.297265625px 1712.3746093749999px',
							'1881.1792968749999px 1712.7749999999999px',
							'1881.1792968749999px 1712.7749999999999px',
							'1876.5027343749998px 1712.7749999999999px',
							'1870.3046874999998px 1712.7749999999999px',
							'1864.4109374999998px 1712.7749999999999px',
							'1864.4109374999998px 1712.7749999999999px',
							'1864.1546875px 1712.7749999999999px',
							'1862.9374999999998px 1712.7749999999999px',
							'1861.4800781249999px 1712.7749999999999px',
							'1859.3179687499999px 1712.7749999999999px',
							'1859.3179687499999px 1712.7749999999999px',
							'1857.9246093749998px 1712.7749999999999px',
							'1857.1558593749999px 1712.7749999999999px',
							'1855.5542968749999px 1713.239453125px',
							'1853.4882812499998px 1713.239453125px',
							'1851.1179687499998px 1713.239453125px',
							'1849.1160156249998px 1713.3835937499998px',
							'1847.4503906249997px 1713.5757812499999px',
							'1845.2722656249998px 1713.5757812499999px',
							'1843.414453125px 1713.5757812499999px',
							'1843.0621093749999px 1713.5757812499999px',
							'1843.0621093749999px 1713.5757812499999px',
							'1842.7097656249998px 1713.5757812499999px',
							'1842.453515625px 1713.5757812499999px',
							'1842.453515625px 1713.5757812499999px',
							'1842.453515625px 1713.6238281249998px',
							'1842.453515625px 1714.488671875px',
							'1842.453515625px 1715.9460937499998px',
							'1842.453515625px 1716.3464843749998px',
							'1842.453515625px 1716.762890625px',
							'1842.773828125px 1717.5957031249998px',
							'1848.219140625px 1719.005078125px',
							'1862.953515625px 1721.5035156249999px',
							'1916.605859375px 1730.1999999999998px',
							'1916.605859375px 1730.1999999999998px',
							'2068.35390625px 1752.157421875px',
							'2163.4386718749997px 1762.45546875px',
							'2337.176171875px 1776.469140625px',
							'2583.496484375px 1798.490625px',
							'2939.1554687499997px 1837.7449218749998px',
							'3147.16640625px 1866.5730468749998px',
							'3193.22734375px 1874.9972656249997px',
							'3232.68984375px 1878.969140625px',
							'3278.6867187499997px 1881.2433593749997px',
							'3352.406640625px 1884.1261718749997px',
							'3384.4058593749996px 1884.7828124999999px',
							'3394.687890625px 1884.7828124999999px',
							'3394.687890625px 1884.7828124999999px',
							'3395.66484375px 1883.133203125px',
							'3396.8019531249997px 1881.7238281249997px',
							'3402.8398437499995px 1879.7539062499998px',
							'3416.6613281249997px 1877.2234374999998px',
							'3436.488671875px 1873.2996093749998px',
							'3445.713671875px 1871.1054687499998px',
							'3482.0050781249997px 1866.797265625px',
							'3552.9703124999996px 1863.7062499999997px',
							'3677.3957031249997px 1861.75234375px',
							'3785.7734374999995px 1859.0136718749998px',
							'3948.3320312499995px 1852.3511718749999px',
							'4099.247265624999px 1852.383203125px',
							'4119.266796874999px 1852.9117187499999px',
							'4140.407421874999px 1854.9937499999999px',
							'4157.68828125px 1858.2929687499998px',
							'4173.591796875px 1862.9054687499997px',
							'4176.10625px 1864.6671874999997px',
							'4177.627734375px 1866.0285156249997px',
							'4177.771874999999px 1866.3328124999998px',
							'4177.8359375px 1866.4609374999998px',
							'4177.8359375px 1866.5890624999997px',
							'4177.8359375px 1866.9894531249997px',
							'4177.8359375px 1866.9894531249997px',
							'4175.001171874999px 1868.8632812499998px',
							'4162.861328125px 1872.2105468749999px',
							'4147.822656249999px 1878.6648437499998px',
							'4141.944921875px 1881.5957031249998px',
							'4131.855078125px 1884.894921875px',
							'4131.855078125px 1884.894921875px',
							'4119.89140625px 1888.4664062499999px',
							'4110.586328124999px 1891.0289062499999px',
							'4106.0859375px 1891.6855468749998px',
							'4100.624609375px 1892.1980468749998px',
							'4095.9640624999997px 1892.6945312499997px',
							'4093.465625px 1893.0308593749999px',
							'4092.8570312499996px 1893.0468749999998px',
						],
						{
							extrapolateLeft: 'clamp',
							extrapolateRight: 'clamp',
						},
					),
				}}
			/>
		</AbsoluteFill>
	);
};

export const KeyframeMovePreview = () => {
	return (
		<CloseUpFrame>
			<KeyframeMoveContent />
		</CloseUpFrame>
	);
};

export const KeyframeMove = () => {
	return (
		<Composition
			id={'KeyframeMove'}
			component={KeyframeMovePreview}
			width={1920}
			height={1080}
			fps={60}
			durationInFrames={183}
		/>
	);
};
